import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import DurationIcon from '@material-ui/icons/Timer';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import 'moment-duration-format';
import React from 'react';
import { withRouter } from 'react-router-dom';
import Gravatar from '../../common/Gravatar';
import LinkRouter from '../../common/LinkRouter';
import TimestampTooltip from '../../common/TimestampTooltip';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    timelineAvatar: {
      marginTop: 0
    },
    timestamp: {
      marginLeft: 4,
      marginRight: 4
    },
    deckVersionLink: {
      marginLeft: 4,
      maxWidth: 100,
      width: 100,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    durationIcon: {
      color: theme.palette.text.secondary,
      margin: '0 4px 0 12px'
    },
    userTooltip: {
      maxWidth: 'none'
    },
    primaryContainer: {
      display: 'flex',
      marginBottom: 4
    },
    secondaryContainer: {
      display: 'flex',
      alignItems: 'center'
    }
  })
);

interface Props {
  events: any[];
  deployment: any;
  onShowLogs: (logId: string) => void;
}

function FaroDeploymentActivityList(props: Props) {
  const { events, deployment, onShowLogs } = props;
  const classes = useStyles({});

  return (
    <List>
      {events.map(event => <ListItem key={`${event.user}::${event.startTime}`} divider>
        <Tooltip
          classes={{ tooltip: classes.userTooltip }}
          title={<React.Fragment>
            <Typography color="inherit" noWrap>{event.user}</Typography>
          </React.Fragment>}
          arrow
        >
          <ListItemAvatar className={classes.timelineAvatar}>
            <Gravatar email={event.user} />
          </ListItemAvatar>
        </Tooltip>
        <ListItemText
          disableTypography
          primary={
            <div className={classes.primaryContainer}>
              {event.action === 'DEPLOY' && <Typography>Created</Typography>}
              {event.action === 'UPDATE' && <Typography>Updated</Typography>}
              <TimestampTooltip timestamp={event.endTime}>
                <Typography
                  className={classes.timestamp}
                  component="span"
                  display="inline"
                >
                  {moment(event.endTime).fromNow()}
                </Typography>
              </TimestampTooltip>
            </div>
          }
          secondary={
            <div className={classes.secondaryContainer}>
              <Typography color="textSecondary" variant="body2">Deck version</Typography>
              <LinkRouter
                className={classes.deckVersionLink}
                color="primary"
                variant="body2"
                to={`/faro/decks/${deployment.DeckName}?version=${encodeURIComponent(event.deckVersion)}`}>
                {event.deckVersion}
              </LinkRouter>
              <DurationIcon className={classes.durationIcon} fontSize="small" />
              <Typography color="textSecondary" variant="body2">{event.duration}</Typography>
            </div>
          }
        />
        {event.logId && <ListItemSecondaryAction>
          <Button size="small" onClick={() => onShowLogs(event.logId)}>View Logs</Button>
        </ListItemSecondaryAction>}
      </ListItem>)}
    </List>
  );

};

export default withRouter(observer(FaroDeploymentActivityList));
